import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram } from 'react-icons/fa';
import './Footer.css';
import logo from '../../assets/images/vistahand-logo.png';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container section-container">

        
        {/* Footer Content Grid */}
        <div className="footer-content">
          
          {/* Brand Section */}
          <div className="footer-section footer-brand">
            <Link to="/" className="footer-brand-link">
              <img src={logo} alt="VistaHand" className="footer-logo-image" loading="lazy" />
            </Link>
            <p className="footer-description">Future of Work - Connecting talent with opportunities globally.</p>
            <div className="social-media">
              <a href="https://facebook.com/2undeobisesan/" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="social-link">
                <FaFacebookF />
              </a>
              <a href="https://twitter.com/ObisesanTony/" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="social-link">
                <FaTwitter />
              </a>
              <a href="https://linkedin.com/company/vistahand/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="social-link">
                <FaLinkedinIn />
              </a>
              <a href="https://instagram.com/vistahand/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="social-link">
                <FaInstagram />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-heading">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/" onClick={() => window.scrollTo(0, 0)}>Home</Link></li>
              <li><Link to="/about" onClick={() => window.scrollTo(0, 0)}>About</Link></li>
              <li><Link to="/services" onClick={() => window.scrollTo(0, 0)}>Services</Link></li>
              <li><Link to="/portfolio" onClick={() => window.scrollTo(0, 0)}>Portfolio</Link></li>
              <li><Link to="/testimonials" onClick={() => window.scrollTo(0, 0)}>Testimonials</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-heading">Services</h4>
            <ul className="footer-links">
              <li><Link to="/services/managed-it" onClick={() => window.scrollTo(0, 0)}>Managed IT (MSP)</Link></li>
              <li><Link to="/services/cloud-infrastructure" onClick={() => window.scrollTo(0, 0)}>Cloud & DevOps</Link></li>
              <li><Link to="/services/automation" onClick={() => window.scrollTo(0, 0)}>AI & Automation</Link></li>
              <li><Link to="/services/cybersecurity" onClick={() => window.scrollTo(0, 0)}>Cybersecurity</Link></li>
              <li><Link to="/services/web-development" onClick={() => window.scrollTo(0, 0)}>Web Development</Link></li>
              <li><Link to="/services/remote-staffing" onClick={() => window.scrollTo(0, 0)}>Virtual Staffing</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-heading">Contact Info</h4>
            <div className="contact-info">
              <div className="contact-item">
                <span className="contact-label">Email:</span>
                <a href="mailto:info@vistahand.com">info@vistahand.com</a>
              </div>
              <div className="contact-item">
                <span className="contact-label">Phone:</span>
                <a href="tel:+353858245872">+353 85 824 5872</a>
              </div>
            </div>
          </div>

        </div>

        
        </div>

      {/* Footer Bottom - placed outside the constrained container so it spans full width */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p>&copy; {currentYear} VistaHand. All rights reserved | All content on this website belongs to VistaHand and is copyright protected.
</p>
          <div className="footer-bottom-links">
            <Link to="/privacy-policy" onClick={() => window.scrollTo(0, 0)}>Privacy Policy</Link>
            <span className="separator">•</span>
            <Link to="/terms-of-service" onClick={() => window.scrollTo(0, 0)}>Terms of Service</Link>
            <span className="separator">•</span>
            <Link to="/cookie-policy" onClick={() => window.scrollTo(0, 0)}>Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
